import { render, staticRenderFns } from "./ImportCredentialStorage.vue?vue&type=template&id=18e56a89&"
import script from "./ImportCredentialStorage.vue?vue&type=script&lang=js&"
export * from "./ImportCredentialStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports